// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordionFaq li {
  list-style: none;
  width: 100%;
  /* margin: 20px; */
  /* padding: 10px; */
}

.accordionFaq li .FaqLabel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  font-family: Inter;
}

.FaqLabel::after {
  content: "+";
  font-size: 40px;
  font-weight: 100;
}

.content p {
  font-weight: 400;
  line-height: 28px;
}

.FaqRadio {
  display: none;
  height: 2rem;
  width: 2rem;
}

.accordionFaq .content {
  padding: 0px;
  line-height: 50px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s, padding 0.5s;
}

.accordionFaq input[type=checkbox]:checked + .FaqLabel {
  color: #45852e;
}

.Obpas-check .FaqLabel::before {
  color: none;
}

.Obpas-check input[type=checkbox]:checked + .FaqLabel {
  color: #45852e;
}

.accordionFaq input[type=checkbox]:checked + .FaqLabel + .content {
  max-height: 400px;
  padding: 10px 10px 10px;
}

.accordionFaq input[type=checkbox]:checked + .FaqLabel::after {
  content: "-";
}

.cardSubText_1 {
  color: #272727;
  font-size: 0.9rem;
}

.disclaimer p {
  word-spacing: 4px;
}

.Termsandcondtion-container .descriptive-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: -0.32px;
  color: rgba(0, 0, 0, 0.9);
}
.Termsandcondtion-container .label-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: -0.16px;
  color: #000;
}
.Termsandcondtion-container .greenlabel-text {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: #45852e;
}
.Termsandcondtion-container .boldlabel-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: -0.16px;
  color: rgba(0, 0, 0, 0.9);
}
.Termsandcondtion-container .divmargin {
  border-bottom: 1px solid #e0e0e0;
  margin-top: 16px;
}

.breadcrumbs {
  font-weight: 400;
  font-size: 14px;
  line-height: 14.4px;
  letter-spacing: -1%;
}

.read-more:hover {
  color: #45842e;
}

.read-more a {
  text-decoration: none;
  color: #212529;
}
.read-more a:hover {
  color: #45842e;
}

.green-text {
  color: #3a7425;
}

.third-party-verification-container {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  font-family: "Inter", sans-serif;
}
.third-party-verification-container .breadcrumbs {
  width: 764px;
  height: 14px;
  margin-bottom: 20px;
}
.third-party-verification-container .title {
  font-weight: 500;
  font-size: 48px;
  line-height: 76.8px;
  letter-spacing: -1px;
  margin-bottom: 30px;
}
.third-party-verification-container .card_custom {
  max-width: 400px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 16px;
  background-color: #fff;
  font-family: "Inter";
}
@media (min-width: 800px) {
  .third-party-verification-container .card_custom {
    max-width: 800px;
  }
}
.third-party-verification-container .card_custom-content_custom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.third-party-verification-container .row_custom {
  display: flex;
  align-items: center;
  border-bottom: 1px solid grey;
  padding: 20px 0;
}
.third-party-verification-container .row_custom:last-child {
  border-bottom: none;
}
.third-party-verification-container .heading {
  margin-right: 10px;
  color: grey;
  font-size: 18px !important;
}
.third-party-verification-container .detail {
  margin-left: auto;
  text-align: end;
  font-size: 14px !important;
}

.proforma-invoice-dowmload {
  border: solid 1px #3370d4;
  border-radius: 0.25rem;
  background-color: rgba(7, 99, 184, 0.1019607843);
  font-weight: bold;
}
.proforma-invoice-dowmload .download-button {
  color: #0763b8;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/features/commonPages/styles.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,yCACI;AAAR;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,iBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;AADJ;;AAKI;EACI,iBAAA;AAFR;;AAOI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAJR;AAOI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AALR;AAQI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AANR;AASI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAPR;AAUI;EACI,gCAAA;EACA,gBAAA;AARR;;AAYA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,cAAA;AATJ;;AAaI;EACI,qBAAA;EACA,cAAA;AAVR;AAaI;EACI,cAAA;AAXR;;AAeA;EACI,cAAA;AAZJ;;AAgBA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;AAbJ;AAeI;EACI,YAAA;EACA,YAAA;EACA,mBAAA;AAbR;AAgBI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAdR;AAiBI;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAfR;AAkBI;EACI;IACI,gBAAA;EAhBV;AACF;AAmBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAjBR;AAmBI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAjBR;AAmBI;EACI,mBAAA;AAjBR;AAoBI;EACI,kBAAA;EACA,WAAA;EACA,0BAAA;AAlBR;AAqBI;EACI,iBAAA;EACA,eAAA;EACA,0BAAA;AAnBR;;AAuBA;EACI,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,iBAAA;AApBJ;AAqBI;EACI,cAAA;EACA,0BAAA;AAnBR","sourcesContent":[".accordionFaq li {\n    list-style: none;\n    width: 100%;\n    /* margin: 20px; */\n    /* padding: 10px; */\n}\n\n.accordionFaq li .FaqLabel {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    font-family: Inter;\n}\n\n.FaqLabel::after {\n    content: '+';\n    font-size: 40px;\n    font-weight: 100;\n}\n\n.content p {\n    font-weight: 400;\n    line-height: 28px;\n}\n\n.FaqRadio {\n    display: none;\n    height: 2rem;\n    width: 2rem;\n}\n\n.accordionFaq .content {\n    padding: 0px;\n    line-height: 50px;\n    max-height: 0;\n    overflow: hidden;\n    transition:\n        max-height 0.5s,\n        padding 0.5s;\n}\n\n.accordionFaq input[type='checkbox']:checked + .FaqLabel {\n    color: #45852e;\n}\n\n.Obpas-check .FaqLabel::before {\n    color: none;\n}\n\n.Obpas-check input[type='checkbox']:checked + .FaqLabel {\n    color: #45852e;\n}\n\n.accordionFaq input[type='checkbox']:checked + .FaqLabel + .content {\n    max-height: 400px;\n    padding: 10px 10px 10px;\n}\n\n.accordionFaq input[type='checkbox']:checked + .FaqLabel::after {\n    content: '-';\n}\n\n.cardSubText_1 {\n    color: #272727;\n    font-size: 0.9rem;\n}\n\n.disclaimer {\n    p {\n        word-spacing: 4px;\n    }\n}\n\n.Termsandcondtion-container {\n    .descriptive-text {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 22.4px;\n        letter-spacing: -0.32px;\n        color: rgba(0, 0, 0, 0.9);\n    }\n\n    .label-text {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22.4px;\n        letter-spacing: -0.16px;\n        color: #000;\n    }\n\n    .greenlabel-text {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 28px;\n        letter-spacing: -0.2px;\n        color: #45852e;\n    }\n\n    .boldlabel-text {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22.4px;\n        letter-spacing: -0.16px;\n        color: rgba(0, 0, 0, 0.9);\n    }\n\n    .divmargin {\n        border-bottom: 1px solid #e0e0e0;\n        margin-top: 16px;\n    }\n}\n\n.breadcrumbs {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 14.4px;\n    letter-spacing: -1%;\n}\n\n.read-more:hover {\n    color: #45842e;\n}\n\n.read-more {\n    a {\n        text-decoration: none;\n        color: #212529;\n    }\n\n    a:hover {\n        color: #45842e;\n    }\n}\n\n.green-text {\n    color: #3a7425;\n}\n\n//Styling for Third Party Verification Component\n.third-party-verification-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 50px;\n    font-family: 'Inter', sans-serif;\n\n    .breadcrumbs {\n        width: 764px;\n        height: 14px;\n        margin-bottom: 20px;\n    }\n\n    .title {\n        font-weight: 500;\n        font-size: 48px;\n        line-height: 76.8px;\n        letter-spacing: -1px;\n        margin-bottom: 30px;\n    }\n\n    .card_custom {\n        max-width: 400px;\n        border: 1px solid #ccc;\n        border-radius: 8px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        border-radius: 30px;\n        padding: 16px;\n        background-color: #fff;\n        font-family: 'Inter';\n    }\n\n    @media (min-width: 800px) {\n        .card_custom {\n            max-width: 800px;\n        }\n    }\n\n    .card_custom-content_custom {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    .row_custom {\n        display: flex;\n        align-items: center;\n        border-bottom: 1px solid grey;\n        padding: 20px 0;\n    }\n    .row_custom:last-child {\n        border-bottom: none;\n    }\n\n    .heading {\n        margin-right: 10px;\n        color: grey;\n        font-size: 18px !important;\n    }\n\n    .detail {\n        margin-left: auto;\n        text-align: end;\n        font-size: 14px !important;\n    }\n}\n\n.proforma-invoice-dowmload {\n    border: solid 1px #3370d4;\n    border-radius: 0.25rem;\n    background-color: #0763b81a;\n    font-weight: bold;\n    .download-button {\n        color: #0763b8;\n        text-decoration: underline;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
